<div class="card-badge" [class.card-badge--tag]="variant() === 'tag'" [class.card-badge--green]="tagColor() === 'green'" [class.card-badge--gold]="tagColor() === 'gold'" [class.card-badge--purple]="tagColor() === 'purple'">
  @if (variant() === 'metric' && iconUrl()) {
    <img [src]="iconUrl()" [alt]="value()">
  }
  @if (translateKey()) {
    <span>{{ value() | translate }}</span>
  } @else {
    <span>{{ value() }}</span>
  }
</div>
